import { HeaderGroup, flexRender } from '@tanstack/react-table';
import styles from './TableHeader.module.scss';

interface TableHeaderProps<TData> {
  getHeaderGroups(): HeaderGroup<TData>[];
  columnMinWidths?: Record<string, number>;
}

export const TableHeader = <T,>({ getHeaderGroups, columnMinWidths }: TableHeaderProps<T>) => (
  <thead className={styles.root}>
    {getHeaderGroups().map((headerGroup) => (
      <tr key={headerGroup.id} className={styles.row}>
        {headerGroup.headers.map((header) => (
          <th
            key={header.id}
            colSpan={header.colSpan}
            className={styles.cell}
            style={
              header.isPlaceholder
                ? undefined
                : {
                    width: `${header.getSize()}px`,
                    minWidth: header.column.columnDef.minSize ?? columnMinWidths?.[header.column.id],
                  }
            }
          >
            {flexRender(header.column.columnDef.header, header.getContext())}
          </th>
        ))}
      </tr>
    ))}
  </thead>
);
